var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.136,
    height: 26.136,
    viewBox: "0 0 26.136 26.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.79,2.615l.865-.865L26.926,27.022l-.865.865-2.168-2.168a3.607,3.607,0,0,1-2.144.694H5.917a3.649,3.649,0,0,1-3.654-3.654V6.926a3.608,3.608,0,0,1,.694-2.144L.79,2.615m5.127.658H21.75A3.649,3.649,0,0,1,25.4,6.926V22.759l-.11.9-1.108-1.1V19.105H20.727l-1.218-1.218h4.677V11.8H18.1v4.677l-1.218-1.218V11.8H13.42L12.2,10.58h4.677V4.49h-6.09V9.167L9.571,7.949V4.49H6.112l-1.1-1.108.9-.11M3.482,6.926V10.58H8.767L3.835,5.659a2.472,2.472,0,0,0-.353,1.267m7.307,10.961h5.286L10.789,12.6v5.286M18.1,25.195H21.75a2.472,2.472,0,0,0,1.267-.353L18.1,19.909v5.286M3.482,22.759a2.443,2.443,0,0,0,2.436,2.436H9.571v-6.09H3.482v3.654M9.571,11.8H3.482v6.09h6.09V11.8M24.186,6.926A2.443,2.443,0,0,0,21.75,4.49H18.1v6.09h6.09V6.926m-13.4,18.269h6.09v-6.09h-6.09Z",
    transform: "translate(-0.79 -1.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGridIcon);
export default __webpack_public_path__ + "static/media/noGridIcon.f3fa3de536e8d55b0dc421e61ba685eb.svg";
export { ForwardRef as ReactComponent };